import gql from 'graphql-tag';
import { apollo } from 'src/features';

const query = gql`
  query Admins{
    answerTemplates {
      id
      text
      value
      markers{
        id
        name
        directory {
          id
          name
        }
      }
    }
  }
`;

function getAnswerTemplates() {
  return apollo.client.query({
    query,
    fetchPolicy: 'network-only',
  }).then((data) => data.data.answerTemplates);
}

export default getAnswerTemplates;
